import { useReducer, useContext, createContext } from "react";
import { admisionReducer } from "./admisionReducer";

const initalState = {
  list: [],
  institutionalRequirementsList: [],
  admissionId: "00000000-0000-0000-0000-000000000000",
  periodId: "00000000-0000-0000-0000-000000000000",
  clasificationId: "00000000-0000-0000-0000-000000000000",
  estadosAdmisionId: "00000000-0000-0000-0000-000000000000",
  campusId: "00000000-0000-0000-0000-000000000000",
  programId: "00000000-0000-0000-0000-000000000000",
  navigatioPage:0
};

const AdmisionStateContext = createContext(initalState);
const AdmisionDspatchContext = createContext(() => {});

export const stateAdmison = () => useContext(AdmisionStateContext);
export const dispatchAdmision = () => useContext(AdmisionDspatchContext);

export const AdmisionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(admisionReducer, initalState);

  return (
    <AdmisionDspatchContext.Provider value={dispatch}>
      <AdmisionStateContext.Provider value={state}>
        {children}
      </AdmisionStateContext.Provider>
    </AdmisionDspatchContext.Provider>
  );
};
